var _excluded = ["id", "label", "className", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';
import { useField } from 'formik';
import { Label, Small } from './Text';
export var SelectPositionContext = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: relative;\n  width: 100%;\n"])));
export var SelectWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  background-color: var(--select-background-color);\n  color: var(--select-font-color);\n  border-radius: var(--select-border-radius, 0);\n\n  /* custom arrow thingy */\n  &::after,\n  &::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 6px;\n    height: 6px;\n    right: 17px;\n    pointer-events: none;\n  }\n\n  &::before {\n    top: 34%;\n    border-top: 2px solid var(--select-arrow-color);\n    border-right: 2px solid var(--select-arrow-color);\n    transform: rotate(-45deg) translate(-50%);\n  }\n\n  &::after {\n    top: 54%;\n    border-bottom: 2px solid var(--select-arrow-color);\n    border-right: 2px solid var(--select-arrow-color);\n    transform: rotate(45deg) translate(-50%);\n  }\n"])));
export var Field = styled.select(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  height: 40px;\n  width: 100%;\n  padding: 7.5px 14.5px 10.5px 15px;\n  background-color: var(--select-background-color);\n  border: 1px solid var(--select-border-color);\n  border-radius: var(--select-border-radius, 0);\n\n  font-size: var(--font-size-base);\n  font-weight: normal;\n  color: var(--select-font-color);\n  outline: none !important;\n\n  /* Hide default arrow thingy */\n  appearance: none!important;\n  &::-ms-expand { display: none; }\n"])));
export var Wrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  &.error {\n    ", ", ", " {\n      color: var(--error-color);\n    }\n\n    ", " {\n      color: var(--error-color);\n      border-color: var(--error-color);\n      background-color: var(--error-background-color);\n    }\n\n    ", " {\n      &::before, &::after {\n        border-color: var(--error-color);\n      }\n    }\n\n    ", " {\n      font-style: italic;\n    }\n  }\n"])), Label, Small, Field, SelectWrapper, Small);
var Select = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useField = useField(_extends({
    id: id
  }, props)),
      field = _useField[0],
      meta = _useField[1];

  var error = meta.touched && meta.error;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: cx(className, {
      error: !!error
    })
  }, label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    className: "mb-2"
  }, label), /*#__PURE__*/React.createElement(SelectPositionContext, null, /*#__PURE__*/React.createElement(SelectWrapper, null, /*#__PURE__*/React.createElement(Field, _extends({
    ref: ref,
    id: id
  }, field, props), children))), error && /*#__PURE__*/React.createElement(Small, {
    "data-testid": "error"
  }, error));
});
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node
} : {};
export default Select;